/**
 * Tours Flavor Module
 *
 * Provides the tour/activity experience: tour listings, tour item cards,
 * booking management, and media gallery for tour photos and highlights.
 *
 * Extends BaseFlavor — all universal handlers (show_items, cart_updated,
 * show_media, dismiss_media) are wired automatically.
 * Reuses RestaurantManager since tours share the same card-based UI.
 */
import { BaseFlavor } from './BaseFlavor.js';
import { RestaurantManager } from '../restaurants/RestaurantManager.js';

class ToursFlavor extends BaseFlavor {
  createManager({ shadowRoot, primaryColor }) {
    return new RestaurantManager({
      shadowRoot,
      primaryColor,
      onItemSelected: (item) => this.handleItemSelected(item),
    });
  }

  getManagerHideMethod() {
    return 'hideMenuItems';
  }
}

export function createToursFlavor(widget, flavor = {}) {
  return new ToursFlavor(widget, flavor);
}
